import getComponent from './get-component';

const getFieldSelectors = () => {
  const component = getComponent();
  return component.getSelectors();
};

export default getFieldSelectors;
